<section data-testid="runner-preconditions">
  <h3 class="rp__head">
    <button
      type="button"
      class="rp__toggle"
      data-testid="runner-preconditions-toggle"
      aria-controls="trm-preconditions-text"
      [attr.aria-expanded]="open()"
      (click)="toggled.emit()"
    >
      <span class="rp__title" data-testid="runner-preconditions-title">
        {{ 'testRunner.preconditions' | translate }}
      </span>
      <span class="rp__hint" data-testid="runner-preconditions-hint">
        {{ (open() ? 'testRunner.preconditionsCollapse' : 'testRunner.preconditionsExpand') | translate }}
      </span>
      <mat-icon class="rp__icon" aria-hidden="true">{{ open() ? 'expand_less' : 'expand_more' }}</mat-icon>
    </button>
  </h3>
  <p class="rp__text" id="trm-preconditions-text" data-testid="runner-preconditions-text" [hidden]="!open()">
    {{ text() }}
  </p>
</section>
